import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-numeric",
  "use": "tamr-icon-numeric-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tamr-icon-numeric\"><g font-size=\"8\" font-family=\"SourceSansPro-Regular, Source Sans Pro\" font-weight=\"normal\" transform=\"translate(2.000000, -1.500000)\"><text id=\"tamr-icon-numeric_1\"><tspan x=\"0\" y=\"8\">1</tspan></text><text id=\"tamr-icon-numeric_2\"><tspan x=\"4\" y=\"12\">2</tspan></text><text id=\"tamr-icon-numeric_3\"><tspan x=\"8\" y=\"16\">3</tspan></text></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol